module.exports = __webpack_public_path__ + "img/after_4_weeks.4fc6adec.svg";